export default "__VITE_ASSET__GcTh67Ms__"